import { AddKnowledgeBaseGroupVariables } from 'api/mutations/knowledgeBase/types'
import { KnowledgeBaseContentResponse } from 'api/queries/knowledgeBase/types'
import { KnowledgeBaseContentType } from 'types/KnowledgeBaseContentType'
import { Translation } from 'types/Translation'

const mapKnowledgeBasePages = (pages: KnowledgeBaseContentResponse[]) => (
  pages.map((page) => page.content.map(({ image, ...item }) => ({
    ...item,
    ...(image ? { image: image.miniaturePath } : {}),
  })))
)

const parseGroupFields = (
  name: string,
  id: number | null,
  nameTranslations: Translation[],
  labelIds: number[]
): AddKnowledgeBaseGroupVariables => ({
  dataType: KnowledgeBaseContentType.GROUP,
  name,
  nameTranslations,
  parentId: id,
  labelIds,
})

export { mapKnowledgeBasePages, parseGroupFields }
